<template>
  <Popover :disabled="disabled">
    <div class="field" :class="{ selected, disabled }">
      <div class="label">{{ label }}</div>
      <DropDownIcon small class="drop" />
    </div>
    <div slot="popover" class="items">
      <template v-for="(item, index) in list">
        <!-- @slot beforeItem 選択肢の前に表示されます -->
        <slot name="beforeItem" :itemKey="item.key" :index="index" />
        <label :key="item.key" v-close-popover>
          <input type="radio" :value="item.key" v-model="_value" />
          <div class="item">{{ item.label }}</div>
        </label>
      </template>
    </div>
  </Popover>
</template>

<script>
import { isMap } from 'lodash'
import Popover, { ClosePopover } from '@/components/molecules/Popover'
import DropDownIcon from '@/components/icons/DropDownIcon'

export default {
  name: 'PopoverSelectBox',
  components: {
    Popover,
    DropDownIcon,
  },
  directives: {
    ClosePopover,
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    /** 値 (v-model) */
    value: [Number, String],
    /** 選択肢 */
    items: [Array, Object, Map],
    /** 非活性 */
    disabled: Boolean,
    /** プレースホルダ */
    placeholder: { type: String, default: '選択してください' },
  },
  computed: {
    _value: {
      get() {
        return this.value
      },
      set(value) {
        /** 値の変更 (v-model) */
        this.$emit('change', value)
      },
    },
    list() {
      if (isMap(this.items)) return Array.from(this.items).map(([key, label]) => ({ key, label }))
      if (this.items instanceof Array) return this.items.map((value, index) => ({ key: index, label: value }))
      return Object.keys(this.items).map(key => ({ key, label: this.items[key] }))
    },
    label() {
      return (isMap(this.items) && this.items.get(this.value)) || this.items[this.value] || this.placeholder
    },
    selected() {
      return this.value !== null && this.value !== undefined
    },
  },
}
</script>

<style lang="postcss" scoped>
.field {
  align-items: center;
  background-color: var(--white);
  border: 1px solid var(--border-color);
  border-radius: 4px;
  box-sizing: border-box;
  color: var(--dark-gray);
  cursor: pointer;
  display: inline-grid;
  font-size: 15px;
  grid-template-columns: 1fr 24px;
  height: 40px;
  min-width: 200px;
  padding: 0 8px 0 16px;

  &.selected {
    color: var(--text-color);
  }

  &.disabled {
    background: var(--mostly-white-1);
    color: var(--text-color);
    cursor: default;
  }
}

.label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.drop {
  opacity: 0.54;
}

.items {
  min-width: 432px;
  padding: 8px 0;

  >>> hr {
    background: var(--very-light-gray);
    border: 0;
    height: 1px;
    margin: 8px 0;
  }
}

input {
  display: none;
}

.item {
  cursor: pointer;
  padding: 8px 16px;

  &:hover {
    background: var(--very-light-gray-2);
  }

  :checked + & {
    background: var(--very-light-yellow);
  }
}
</style>
